<div class="page">

  <ng-content></ng-content>
</div>
